import React from "react";
import { IList } from "../../../utils/generalType";
import { servicesPortfolio } from "./Services/service.utils";
import Slide from "react-reveal/Slide";
import PortServiceWorkFlowComp from "./portfolio_Service_workflow";

const PortServicesComp = () => {
  const services: IList[] = servicesPortfolio;

  return (
    <div className="text-gray-700">
      {/* Services Section */}
      <div className="py-16 bg-gray-100">
        <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <Slide bottom delay={index * 200} key={index}>
              <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
                <div className="text-3xl mb-4">{service.icon}</div>
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-md">{service.desc}</p>
              </div>
            </Slide>
          ))}
        </div>
      </div>

      {/* Workflow Section */}
      <PortServiceWorkFlowComp></PortServiceWorkFlowComp>
    </div>
  );
};

export default PortServicesComp;
